module.exports = __webpack_public_path__ + "img/double_silver.46c2d86f.svg";